import { undo, redo, isUndoable, isRedoable } from '../store/History/stateHistory';
import { mapMutations } from 'vuex'

export const undoRedo = {
  computed: {
    isUndoable: function () {
      return isUndoable();
    },

    isRedoable: function () {
      return isRedoable();
    }
  },

  methods: {
    ...mapMutations(['updateTags', 'updateSelection']),

    undo: function () {
      let undoneState;
      undoneState = undo();

      if (undoneState) {
        undoneState['tags'] && this.updateTags(undoneState['tags']);
        undoneState['selection'] && this.updateSelection(undoneState['selection']);
      }
    },

    redo: function () {
      let redoneState;
      redoneState = redo();

      if (redoneState) {
        redoneState['tags'] && this.updateTags(redoneState['tags']);
        redoneState['selection'] && this.updateSelection(redoneState['selection']);
      }
    }
  }
}